import {makeStyles, createStyles} from '@material-ui/core/styles'


const useFontStyles = makeStyles(theme =>
    createStyles({

        companyText: {
            fontFamily: 'Permanent Marker',
            color: 'white',
            fontSize: 72
        },

        infoSpan: {
            fontFamily: 'Akaya Telivigala',
            color: '#fff',
        },

        /*Session*/

        sessionText: {
            fontFamily: 'Shippori Mincho B1',
            fontSize: 12,
            color: '#fafafa',
            marginLeft: 7,
            cursor: 'pointer',
            fontWeight: '500',
            "&:hover": {
                color: '#fff',
                fontWeight: 'bold'
            },
        },

        iconSession: {
            color: '#fff',
            fontSize: 12,
        },

        hoverText: {
            fontFamily: 'Shippori Mincho B1',
            fontSize: 12,
            color: '#333',
            cursor: 'pointer',
            fontWeight: '500',
            "&:hover": {
                color: 'gray',
                fontWeight: 'bold'
            },
        },

        generalText: {
            fontFamily: 'Shippori Mincho B1',
            fontSize: 12,
            color: '#333',
            fontWeight: '500',
        }
    })
)

export {useFontStyles}